/* Stylised single-leaf maple silhouette — used as a Canadian flourish, not a flag. */
export default function MapleLeaf({ size = 16, color = "currentColor", className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      fill={color}
    >
      <path d="M50 6 L54 26 L72 17 L66 36 L86 32 L74 47 L92 54 L74 60 L86 75 L66 71 L72 90 L54 81 L50 100 L46 81 L28 90 L34 71 L14 75 L26 60 L8 54 L26 47 L14 32 L34 36 L28 17 L46 26 Z" />
    </svg>
  );
}
